import { Link as RouterLink } from 'react-router-dom';

import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import CallMadeIcon from '@mui/icons-material/CallMade';

import {
  LicensingTermsAvatar,
  LicensingTermsLink,
  LicensingTermsWrapper,
} from '../../../styled/Sidebar.styled';

const LicensingTerms = () => {
  return (
    <LicensingTermsWrapper>
      <ListItem>
        <ListItemAvatar>
          <LicensingTermsAvatar>
            <CallMadeIcon fontSize="small" />
          </LicensingTermsAvatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <LicensingTermsLink component={RouterLink} to="/license">
              Умови публічної ліцензії
            </LicensingTermsLink>
          }
          secondary={
            <LicensingTermsLink href="https://odd-firefly-5079.axels-dev-chat.workers.dev/license.pdf">
              Скачати
            </LicensingTermsLink>
          }
        />
      </ListItem>
    </LicensingTermsWrapper>
  );
};

export default LicensingTerms;
